import { COLORS } from "../../../constants";
import {
  PAGINATION_INDEXING,
  PAGINATION_PAGE_SIZES,
} from "../../../constants/reactTable/reactTable.constants";

export const campaignMetricsConstants = {
  CAMPAIGN_METRICS_SPINNER: "CAMPAIGN_METRICS_SPINNER",
  GET_CAMPAIGN_METRICS: "GET_CAMPAIGN_METRICS",
  DELIVERY_COUNT: "Delivery Count",
  UNIQUE_CUSTOMER_COUNT: "Unique Customer Count",
};

export const CAMPAIGN_METRICS_LABELS = Object.freeze({
  TABLE_TITLE: "Campaign Metrics:",
  TABLE_KEY: "campaignMatrics",
  DELETED: "Deleted",
});
export const CAMPAIGN_METRICS_PAGINATION = Object.freeze({
  PAGE_SIZES: [PAGINATION_PAGE_SIZES.COMPACT],
  INITIAL: {
    pageSize: PAGINATION_PAGE_SIZES.COMPACT,
    totalElements: 0,
    pageNumber: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  },
});

const { DELIVERY_COUNT, UNIQUE_CUSTOMER_COUNT } = campaignMetricsConstants;

const CAMPAIGN_METRICS_LABEL_POSITIONS = [
  "left",
  "right",
  "top",
  "bottom",
  "inside",
  "insideTop",
  "insideLeft",
  "insideRight",
  "insideBottom",
  "insideTopLeft",
  "insideTopRight",
  "insideBottomLeft",
  "insideBottomRight",
];

//Label option for charts
export const CAMPAIGN_METRICS_CHART_LABEL = {
  show: true,
  position: {
    options: CAMPAIGN_METRICS_LABEL_POSITIONS.reduce(function (positions, position) {
      positions[position] = position;
      return positions;
    }, {}),
  },
  distance: {
    min: 0,
    max: 100,
  },
  align: {
    options: {
      left: "left",
      center: "center",
      right: "right",
    },
  },
  verticalAlign: {
    options: {
      top: "top",
      middle: "middle",
      bottom: "bottom",
    },
  },
};

export const CAMPAIGN_METRICS_CHART_OPTIONS = {
  color: [COLORS.BRIGHT_GREEN, COLORS.ROYAL_BLUE, COLORS.GOLDEN_YELLOW],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    data: [DELIVERY_COUNT, UNIQUE_CUSTOMER_COUNT],
  },
  toolbox: {
    show: true,
    orient: "vertical",
    left: "right",
    top: "center",
    feature: {
      mark: { show: true },
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ["line", "bar", "stack"] },
      restore: { show: true },
      saveAsImage: { show: true },
    },
  },
};

export const CAMPAIGN_METRICS_CHART_SERIES = {
  type: "bar",
  barGap: 0.1,
  barWidth: "10%",
  label: CAMPAIGN_METRICS_CHART_LABEL,
  emphasis: {
    focus: "series",
  },
};
